const defaultInitials = name => (name && name?.substring(0, 2).toUpperCase()) || '';
export default defaultInitials;
